import axios from "axios";
import VueCookie from "vue-cookie";

let ax = axios.create({
    baseURL: process.env.VUE_APP_API,
    withCredentials: true
});
axios.defaults.headers.common["Access-Control-Allow-Credentials"] = "true";

ax.interceptors.request.use(function(config) {
    return config;
});
ax.interceptors.response.use(
    function(response) {
        // Nichts weiter zu tun
        return response;
    },
    function(error) {
        if (error.response.status === 401 || error.response.status === 403) {
            // Zur ausgeloggt Seite umleiten
            VueCookie.delete("data_token");
            window.location.href = "/ausgeloggt";
        }
        return Promise.reject(error);
    }
);

export default ax;
